/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import { keepLatestTask } from 'ember-concurrency';
import { ObjectTypeUsage } from 'cio/models/object-type';
import EnvironmentService from 'cio/services/environment';
import AccountService from 'cio/services/account';

export default class SettingsObjectsComponent extends Component {
  @service store!: DS.Store;
  @service environment!: EnvironmentService;
  @service account!: AccountService;

  objectTypesUsage: Record<string, ObjectTypeUsage> = {};

  @tracked isObjectFeedbackFormModalVisible = false;

  constructor(owner: unknown, args: Record<string, never>) {
    super(owner, args);

    this.loadObjectTypes.perform();
  }

  get objectTypes() {
    return this.store.peekAll('object-type');
  }

  get objectsAllotted() {
    let usage = this.account.current.get('usage');
    if (usage?.objectsAllotted == null) {
      return '';
    }
    return `, and includes ${usage.objectsAllotted} Object Profiles for free`;
  }

  loadObjectTypes = keepLatestTask(async () => {
    let objectTypes = await this.store.findAll('object-type');

    // caching object type usage because we don't get this info in env API call with object types as it is too expensive
    this.objectTypesUsage = objectTypes.toArray().reduce(
      (acc, objectType) => {
        acc[objectType.id] = objectType.usage;

        return acc;
      },
      {} as typeof this.objectTypesUsage,
    );

    return objectTypes;
  });

  @action
  toggleObjectFeedbackFormModal(show: boolean) {
    this.isObjectFeedbackFormModalVisible = show;
  }
}
